var map = {
	"./01.svg": "bc75",
	"./02.svg": "0165",
	"./alphabet-left-frame.svg": "c941",
	"./alphabet-main-frame.svg": "4514",
	"./alphabet-right-frame.svg": "3436",
	"./autoplay-all.svg": "0fcb",
	"./black-outline.svg": "77ec",
	"./dbyloi-desktop-logo.svg": "21c7",
	"./dbyloi-logo.svg": "17c6",
	"./dbyloi-mobile-logo.svg": "2a93",
	"./dbyloi-no-strap.svg": "6e69",
	"./desktop-logo.svg": "b22f",
	"./do-something.svg": "bc65",
	"./eat.svg": "d17d",
	"./exercise.svg": "94b7",
	"./facebook-colour.svg": "dcd8",
	"./facebook-greyscale.svg": "c93c",
	"./gamban-colour.svg": "680e",
	"./gamban-greyscale.svg": "17c5",
	"./gamblers-anonymous-colour.svg": "7db6",
	"./gamblers-anonymous-greyscale.svg": "498d",
	"./gamcare-colour.svg": "04c8",
	"./gamcare-greyscale.svg": "cc6f",
	"./gamstop-colour.svg": "5629",
	"./gamstop-greyscale.svg": "6df4",
	"./google-play.svg": "5d46",
	"./itunes-store.svg": "1146",
	"./pause-white.svg": "72b9",
	"./pause.svg": "54a0",
	"./pgs-ara-bct.svg": "7f9b",
	"./play-sound.svg": "b755",
	"./play-white.svg": "1cb3",
	"./play.svg": "b7a6",
	"./playing.svg": "1a37",
	"./plus.svg": "cc33",
	"./samaritans-colour.svg": "e3d3",
	"./samaritans-greyscale.svg": "a908",
	"./scrub-back.svg": "55ae",
	"./scrub-forward.svg": "8be9",
	"./share.svg": "8178",
	"./sleep.svg": "4b11",
	"./sound-white.svg": "69ef",
	"./sound.svg": "6ae3",
	"./the-national-gambling-helpline-colour.svg": "65ef",
	"./the-national-gambling-helpline-greyscale.svg": "5ef1",
	"./twitter-colour.svg": "584c",
	"./twitter-greyscale.svg": "54ba",
	"./uk-flag.svg": "c57e",
	"./x.svg": "b931",
	"./youtube-colour.svg": "d07a",
	"./youtube-greyscale.svg": "90bb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "84ab";